import type { ICellRendererParams } from 'ag-grid-community';
import { Icon } from '@seeqdev/qomponents';
import type { Stages } from '@/impactReports/impactReport.types';
import { availableStages, stageIcons } from '@/impactReports/impactReport.types';
import { stageDisplayStringByIndex } from '@/impactReports/impactReport.utilities';

/**
 * This cell-renderer renders a little icon next to the use case status to indicate the current stage of the use case.
 */
export const UseCaseStatusCellRenderer: React.FunctionComponent<ICellRendererParams<any, string>> = (props) => {
  if (!props?.value) return null;
  const { value } = props;
  if (!value) return null;
  let stageIndex = availableStages.indexOf(value?.trim().toLowerCase() as unknown as Stages);

  if (stageIndex < 0) stageIndex = 0;

  return stageIndex >= 0 ? (
    <div className="flexColumnContainer flexAlignCenter">
      <Icon icon={stageIcons[stageIndex]} extraClassNames="mr5" testId="stageIcon" />
      {stageDisplayStringByIndex(stageIndex)}
    </div>
  ) : null;
};
